import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa";

import { CiDeliveryTruck } from "react-icons/ci";
import moment from "moment";
import { toast } from "react-toastify";


const ReferralAddressChargesModal = ({
  combinePromoData,
  show,
  setShow,
  applyButton,
  handleRemovePromo,
  handleApplyPromo,
  deliveryCharge,
  finalValue,
  totalValue,
  promoClickData,
  appliedPromoId,
  setShowAddressModal,
  topUsersData,
}) => {

  const handleClose = () => {
    setShow();
  };
  const [expandedPromoId, setExpandedPromoId] = useState(null);

  const toggleDetails = (id) => {
    setExpandedPromoId(expandedPromoId === id ? null : id);
  };
  return (
    <Modal
      show={show?.Id || show}
      onHide={handleClose}
      backdrop="static"
      className="payment_modal_promo"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title claim-Product-main-heading">
          Claim Product
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="claim-Product-container  align-items-center mb-2">
          <div className="Image-forModal-popup">
            <h5>
              <CiDeliveryTruck />
              Delivery Charges{" "}
              <span>₹ {show?.DeliveryCharges || 0}</span>
            </h5>
          </div>
          <div className="claim-Product-Inner-container ml-3"></div>
        </div>
        {combinePromoData?.length ? (
          <div className="claim-Product-PromoCode-Container mb-4">
            <h3>Promo Codes</h3>
            {combinePromoData?.map((item) => {
              return (
                <div className="promo-code-item  justify-content-between align-items-center mb-2">
                  <h4>
                    {item?.PromoCode}
                    <button
                      type="button"
                      className="promo_view_dtal_btn btn-sm relaunch-btn btn-info"
                      onClick={() => toggleDetails(item?.Id)}
                    >
                      View Details <FaChevronDown className="arrow_down_pro" />
                    </button>
                  </h4>
                  {expandedPromoId === item?.Id && (
                    <div className="promo-code-details">
                      <p>{item?.Description}</p>
                      <p>
                        Validity: {moment(item?.ToDate).format("YYYY-MM-DD")}
                        
                      </p>
                    </div>
                  )}

                  {/* <div className="promo-code-details">
                    <p>{item?.Description}</p>
                    <p>Validity: {moment(item?.ToDate).format()}</p>
                  </div> */}
                  {appliedPromoId === item?.Id ? (
                    <button
                      type="button"
                      className="apply_btn btn-sm "
                      onClick={() => handleRemovePromo()}
                    >
                      Remove
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="apply_btn btn-sm "
                      onClick={() => handleApplyPromo(item)}
                    >
                      Apply
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        ) : null}

        <div className="claim-Product-container mb-2 mt-2">
          <h5>
            Delivery charge{" "}
            <span>₹ {show?.DeliveryCharges}</span>
          </h5>
        </div>
        <hr className="Modal_hr-line" />
        <div className="Modal-total-section">
          <h5>
            Total
            <span>₹ {applyButton ? finalValue : totalValue}</span>
          </h5>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="CheckoutButton"
          onClick={() => {
            if (
              topUsersData?.length ==
              topUsersData?.filter((i) => i?.IsUsed == true)?.length
            ) {
              toast.error("Not enough referrals to claim reward ");
            } else {
              setShowAddressModal(show);
              handleClose();
            }
          }}
        >
          Checkout
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReferralAddressChargesModal;
